export class Authentication {
  isAuthenticated: boolean;
  token: string;
  user: any;
}
